import { plainToInstance } from 'class-transformer'
import { Entity } from '../entity'
import { ISiteBoxDocumentConfigResult } from './ISiteBoxDocumentConfigResult'
import { ISiteBoxDocumentConfigResultOutput } from './ISiteBoxDocumentConfigResultOutput'
import { QueryAppraisalStatus } from './types'

export class SiteBoxDocumentConfigResult extends Entity<ISiteBoxDocumentConfigResult> {
  id: string
  query: string
  returnType: string
  result: {
    output: ISiteBoxDocumentConfigResultOutput
    evidence: [{ quote: string; location: [{ page: number }] }]
    errors: [string]
    status: string
    reasoning: string
  }
  userResponse?: QueryAppraisalStatus
  additionalComment?: string

  public static new(payload: ISiteBoxDocumentConfigResult) {
    return plainToInstance(SiteBoxDocumentConfigResult, payload)
  }

  public static newArray(payload: ISiteBoxDocumentConfigResult[]) {
    return payload.map(SiteBoxDocumentConfigResult.new)
  }

  public isAppraised(): boolean {
    return (
      this.userResponse === 'PASS' ||
      this.userResponse === 'FAIL' ||
      this.userResponse === 'NA'
    )
  }

  public static areAllQueriesAppraised(
    results: ISiteBoxDocumentConfigResult[],
  ): boolean {
    return results?.every(
      (r) =>
        r.userResponse === 'PASS' ||
        r.userResponse === 'FAIL' ||
        r.userResponse === 'NA',
    )
  }

  public static hasAnyAppraised(
    results: ISiteBoxDocumentConfigResult[],
  ): boolean {
    return results?.some(
      (r) =>
        r.userResponse === 'PASS' ||
        r.userResponse === 'FAIL' ||
        r.userResponse === 'NA',
    )
  }

  public static findFirstUnappraisedIndex(
    results: ISiteBoxDocumentConfigResult[],
  ): number {
    return results?.findIndex(
      (r) =>
        r.userResponse !== 'PASS' &&
        r.userResponse !== 'FAIL' &&
        r.userResponse !== 'NA',
    )
  }

  public getEvidencePages(): number[] {
    const evidence = this.result?.evidence || []
    return Array.from(
      new Set(evidence.flatMap((e) => e.location.map((loc) => loc.page))),
    ).sort((a, b) => a - b)
  }

  public hasEvidence(): boolean {
    return (this.result?.evidence?.length ?? 0) > 0
  }
}
